import * as React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {resourcesHelper} from "@ferry/portal-core";
import {formatDate} from "@ferry/plugin-ferry-journey";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    expiryDate: string;
}

export const RenewalCancelConfirmationModal: React.FC<IProps> = ({ isOpen, onClose, expiryDate }) => {
    const closeBtn = <button className="btn-close" onClick={onClose} />;

    return (
        <Modal isOpen={isOpen} className="info-modal">
            <ModalHeader close={closeBtn}>
                <div className="d-flex">
                    <img
                        className="purchase-success-icon d-block"
                        src={`/${resourcesHelper.THEME_PATH}/img/check-mark-green-light.svg`}
                        alt="DriveAway complete confirmation"
                        aria-label="DriveAway complete picture"
                    />
                    <div className="font-weight-medium">
                        You’ve cancelled your renewal!</div>
                </div>
            </ModalHeader>
            <ModalBody>
                <p>
                    <strong>Your policy will now end on {formatDate(expiryDate, "DD MMM YYYY")}.</strong>
                    <br />
                    You may still receive a renewal reminder but this can be ignored.
                </p>
            </ModalBody>
            <ModalFooter>
                <button className="btn-primary btn-next" onClick={onClose}>
                    Ok, I understand
                </button>
            </ModalFooter>
        </Modal>
    );
};
